import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
      <div className="container">
        <Link className="navbar-brand fw-bold" to="/">
          <i className="bi bi-layers me-2"></i>
          WebVenly
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarNav"
        >
          <ul className="navbar-nav d-flex flex-column flex-lg-row align-items-center gap-2 ms-lg-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/features">
                <i className="bi bi-gear me-1"></i>
                Features
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/solutions">
                <i className="bi bi-lightbulb me-1"></i>
                Solutions
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/pricing">
                <i className="bi bi-tag me-1"></i>
                Pricing
              </Link>
            </li>

            {/* Resources Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-collection me-1"></i>
                Resources
              </a>
              <ul className="dropdown-menu dropdown-menu-dark">
                <li>
                  <Link className="dropdown-item" to="/roadmap">
                    <i className="bi bi-map me-2"></i>
                    Product Roadmap
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/videos">
                    <i className="bi bi-play-circle me-2"></i>
                    Training Videos
                  </Link>
                </li>
                {/* <li>
                  <Link className="dropdown-item" to="/documentation">
                    <i className="bi bi-file-text me-2"></i>
                    Documentation
                  </Link>
                </li> */}
                {/* <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link className="dropdown-item" to="/case-studies">
                    <i className="bi bi-graph-up me-2"></i>
                    Case Studies
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/webinars">
                    <i className="bi bi-camera-video me-2"></i>
                    Webinars
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/blog">
                    <i className="bi bi-journal-text me-2"></i>
                    Blog
                  </Link>
                </li> */}
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/demo">
                <i className="bi bi-calendar-check me-1"></i>
                Book a Demo
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                <i className="bi bi-envelope me-1"></i>
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link className="btn btn-outline-light ms-3" to="/login">
                <i className="bi bi-box-arrow-in-right me-1"></i>
                Login
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
